import { render } from "./CRMDashboardCurrentCRMWhatsappConversationsComponent.vue?vue&type=template&id=67426536"
import script from "./CRMDashboardCurrentCRMWhatsappConversationsComponent.vue?vue&type=script&lang=js"
export * from "./CRMDashboardCurrentCRMWhatsappConversationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__